<template>
  <twitch-clips-search @errorUpdate="errorUpdate" />
</template>

<script>
import TwitchClipsSearch from '@/components/TwitchVideoSearch'

export default {
  name: 'Video',
  components: {
    TwitchClipsSearch,
  },
  mounted: function() {
    // Redirect from legacy
    if(this.$router.currentRoute.query.user) {
      this.$router.push("vods/" + this.$router.currentRoute.query.user)
      location.reload()
    }
  },
  methods: {
    errorUpdate: function(e) {
      this.$emit('errorUpdate', e)
    },
  },
}
</script>

<style>
</style>